import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { PaginatorModule } from 'primeng/paginator';
import { TabViewModule } from 'primeng/tabview';
import { SwiperModule } from 'swiper/angular';
import { SharedModule } from './../shared/shared.module';
import { AboutkypageComponent } from './aboutpages/aboutkypage/aboutkypage.component';
import { CopyrightComponent } from './claims/copyright/copyright.component';
import { InfoSecurityComponent } from './claims/info-security/info-security.component';
import { PrivacyComponent } from './claims/privacy/privacy.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CorporatePhilosophyComponent } from './corporate-philosophy/corporate-philosophy.component';
import { IndexComponent } from './index/index.component';
import { NewsCenterComponent } from './news/news-center/news-center.component'; // ** 主頁
import { NewsComponent } from './news/news/news.component'; // ** 內頁
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ProductComponent } from './products/product/product.component'; // ** 內頁
import { ProductsComponent } from './products/products/products.component'; // ** 主頁
import { HumanRecruitComponent } from './recruitpages/human-recruit/human-recruit.component';
import { SolutionExploreComponent } from './solutions/solution-explore/solution-explore.component';
import { SolutionsComponent } from './solutions/solutions/solutions.component';
import { SuccessComponent } from './solutions/success/success.component';
import { PsirtComponent } from './psirt/psirt.component';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        RouterModule,
        SharedModule,
        SwiperModule,
        TabViewModule,
        PaginatorModule,
        ReactiveFormsModule,
        InputTextareaModule,
    ],
    declarations: [
        IndexComponent,
        AboutkypageComponent,
        ProductsComponent,
        ProductComponent,
        SuccessComponent,
        SolutionsComponent,
        SolutionExploreComponent,
        NewsComponent,
        NewsCenterComponent,
        PageNotFoundComponent,
        HumanRecruitComponent,
        PrivacyComponent,
        InfoSecurityComponent,
        CopyrightComponent,
        ContactUsComponent,
        CorporatePhilosophyComponent,
        PsirtComponent,
    ],
    exports: [],
    providers: [],
})
export class PagesModule {}
